export default "__VITE_ASSET__0137b889__"